<template>
  <div>
    <div>
      <v-file-input accept=".docx" v-model="chosenFile" label="Загрузить шаблон (docx)"
        @change="addTemplate($event)"></v-file-input>
    </div>
    <template v-if="templates !== null">
      <table>
        <thead>
          <tr>
            <td>Имя</td>
            <td>Активный</td>
            <td>Загрузил</td>
            <td>Используется</td>
            <td>Удалить</td>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(template, index) in templates" :key="index"
            :style="{ backgroundColor: (index % 2 == 0 ? '#EAEAEA' : 'transparent') }">
            <td>
              <a :href="'routers/router.php?action=downloadTemplate&id=' + template.id">
                {{ template.name }}
                <br />
                <span v-if="template.comment != null">({{ template.comment }})</span>
              </a>
            </td>
            <td v-on:click="toggleActive(template)" style="cursor:pointer">
              <div v-if="template.active" style="color:green">Да</div>
              <div v-else>Нет</div>
            </td>
            <td>{{ template.uname }}</td>
            <td>
              {{ template.count }} документов
              <img class="button" alt="переместить" title="переместить" :src="$model.wwwroot + '/pix/t/move.png'"
                @click.stop="moveDocument(template)" />
            </td>
            <td>
              <v-icon class="cursor-pointer" title="Удалить" color="red lighten-2"
                @click.stop="deleteTemplate(template)">
                mdi-delete
              </v-icon>
            </td>
          </tr>
        </tbody>
      </table>
    </template>
    <template v-else>
      <v-skeleton-loader type="article"></v-skeleton-loader>
    </template>

    <v-dialog v-model="moveDocumentDialog" v-if="moveDocumentDialog" width="600">
      <v-card>
        <v-card-title class="grey lighten-4">Изменить шаблон документов</v-card-title>
        <v-card-text>
          <p>Установить новый шаблон для документов, использующих {{ editTemplate.name }}</p>
          <v-select v-model="templateToSet" :items="templatesToSet" item-title="name" item-value="id"
            label="Тип переменной">
          </v-select>
        </v-card-text>

        <v-card-actions class="grey lighten-4">
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="setNewTemplate()">Сохранить</v-btn>
          <v-btn color="primary" @click="moveDocumentDialog = false">Закрыть</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <confirmdlg ref="confirm" />
  </div>
</template>

<script>
import confirmDialog from 'moodleDir/procollege/lib/vue/confirm-dialog.vue';
export default {
  data() {
    return {
      templates: null,
      editTemplate: null,
      templateToSet: null,
      templatesToSet: [],
      moveDocumentDialog: false,
      chosenFile: []
    };
  },
  props: {
    categoryid: false,
    saved: Boolean
  },
  components: {
    confirmdlg: confirmDialog,
  },
  created() {
    this.axios
      .post(
        this.$model.wwwroot + "/procollege/manage_groups/documents3/categoryGetTemplates",
        new URLSearchParams({
          categoryid: this.categoryid
        })
      )
      .then((response) => {
        this.settingsLoaded(response.data);
      })
      .catch((error) => {
        this.axiosDefaultErrorHandler(error);
      });


    this.$eventBus.$on("save-category", categoryid => {
      this.$emit("update:saved", true);
    });

    this.$emit("update:saved", false);
  },
  methods: {
    settingsLoaded(resp) {
      this.templates = resp;
    },

    addTemplate(file) {
      if (file.length == 0) {
        return;
      }
      let data = new FormData();
      data.append("file", file);
      data.append("categoryid", this.categoryid);

      this.axios
        .post(
          this.$model.wwwroot + "/procollege/manage_groups/documents3/categorySetTemplates",
          data
        )
        .then((response) => {
          this.settingsLoaded(response.data);
        })
        .catch((error) => {
          this.axiosDefaultErrorHandler(error);
        });

      this.chosenFile = [];
    },
    toggleActive(template) {
      if (template.document == "default") {
        return;
      }
      for (let key in this.templates) {
        if (this.templates[key] != template) {

          if (this.templates[key].active) {
            this.templates[key].active = 0;
            this.updateTemplate(this.templates[key]);
          }
          this.templates[key].active = 0;
        } else {
          template.active = !template.active;
        }
      }

      this.updateTemplate(template);
    },
    updateTemplate(template) {
      this.axios
        .post(
          this.$model.wwwroot + "/procollege/manage_groups/documents3/categoryUpdateTemplate",
          new URLSearchParams({
            data: JSON.stringify(template)
          })
        )
        .then((response) => {
          this.settingsLoaded(response.data);
        })
        .catch((error) => {
          this.axiosDefaultErrorHandler(error);
        });
    },
    moveDocument(template) {
      this.templatesToSet = [];
      for (let key in this.templates) {
        if (template.id != this.templates[key].id && this.templates[key].document != "default") {
          this.templatesToSet.push(this.templates[key]);
        }
      }
      this.editTemplate = template;
      this.moveDocumentDialog = true;
    },
    setNewTemplate() {
      this.axios
        .post(
          this.$model.wwwroot + "/procollege/manage_groups/documents3/categorySetNewTemplate",
          new URLSearchParams({
            oldTemplate: this.editTemplate.id,
            template: this.templateToSet.id,
            categoryid: this.categoryid,
          })
        )
        .then((response) => {
          this.settingsLoaded(response.data);
        })
        .catch((error) => {
          this.axiosDefaultErrorHandler(error);
        });

      this.moveDocumentDialog = false;
    },
    async deleteTemplate(template) {
      if (template.document == "default") {
        this.$eventBus.$emit("show-dialog", {
          title: "Ошибка",
          content: "невозможно удалить образец",
        });
        return;
      }
      if (template.count > 0) {
        this.moveDocument(template);
      } else {
        if (
          await this.$refs.confirm.open(
            "Подтверждение",
            "Вы действительно хотите удалить шаблон?"
          )
        ) {
          this.axios
            .post(
              this.$model.wwwroot + "/procollege/manage_groups/documents3/categoryDeleteTemplate",
              new URLSearchParams({
                template: template.id,
                categoryid: this.categoryid,
              })
            )
            .then((response) => {
              this.settingsLoaded(response.data);
            })
            .catch((error) => {
              this.axiosDefaultErrorHandler(error);
            });
        }
      }
    }
  }
};
</script>
<style scoped>
table {
  width: 100%;
  border-spacing: 0;
  color: #000;
  margin-top: 5px;
}

table>thead {
  background: #e4e9ee;
}

td {
  color: black;
  padding: 10px 5px;
  width: 200px;
  border-left: 1px solid #ffffff;
  border-right: none;
  color: dimgray;
}

img.button {
  cursor: pointer;
  width: 16px;
}
</style>
